import { Address } from 'viem';

export enum BondDisclaimerVersion {
  V1 = 'v1',
  V1Hash = 'v1_hash',
}

export type AcceptDisclaimerBody = {
  address: Address;
  disclaimerVersion: BondDisclaimerVersion;
  signature: string;
  timestamp: number;
};

export interface BondsInfoDto {
  nativePrice: string;
  bondFundWalletUsd: string;
  currentNftPriceNative: string;
  FUND_WALLET: string;
  isNftPriceValid: boolean;
  isEnabled?: boolean;
}

export interface SignRedeemDto {
  params: {
    amountNfts: number;
    deadline: number;
    nonce: string;
    seller: string;
    totalSellPrice: string;
    uuid: string;
  };
  signature: string;
}

export interface SignMintAndApplyDto {
  apply: {
    id: number;
    referralCode: string;
    referrerUserRegisteredAt: string;
    referrerCode: string;
    isEligibleToApplyRefCode: boolean;
  };
  mint: {
    params: {
      amountNfts: number;
      deadline: number;
      nonce: string;
      paymentAmount: string;
      receiver: string;
      uuid: string;
    };
    signature: string;
  };
}

export interface ReferralMeDto {
  id: number;
  holdBalance: number;
  isEligibleToApplyRefCode: boolean;
  referralCode: string;
  referrals: {
    count: number;
    totalHoldBalance: number;
    totalRewardPoolBalance: number;
  };
  referrerUserRegisteredAt: string | null;
  referrerCode: string | null;
  rewardPoolBalance: number;
  totalReferralsCount: number;
}

export interface BondsTotalRewardsDistributedDto {
  amountUsd: string;
}

export enum BondsAction {
  Mint = 'mint',
  Transfer = 'transfer_by_operator',
}

export interface BondsActionHistoryDto {
  action: BondsAction;
  datetime: string;
  id: number;
  nftsAmount: string;
  paymentAmountNative: string;
  paymentAmountUsd: string;
  txHash: string;
}

export interface BondsPerformanceMetricsDto {
  netDeposits: string;
  totalProfits: string;
  // Used by UserStats (Percentage Ownership / Rank). Verify Bernard's backend
  // populates these — UserStats degrades to a skeleton when they're missing.
  bondsHoldRank: number;
  bondsHoldShare: number;
}

export type PersonalKpiDto = {
  dailyYield: string;
  dailyProfit: string;
  avgApy: string;
};

export interface BondsChartPointDto {
  tvl: string;
  totalSupply: string;
  dateTime: string;
  apr: string;
  priceInUsd: string;
}
